/**
 * Platform Detection Utilities
 * Detects iOS, Android, or Web platform for platform-specific features
 */

import { Capacitor } from '@capacitor/core';

export type Platform = 'ios' | 'android' | 'web';

/**
 * Get the current platform
 */
export const getPlatform = (): Platform => {
  if (typeof window === 'undefined') {
    return 'web';
  }

  if (Capacitor.isNativePlatform()) {
    const platform = Capacitor.getPlatform();
    return platform as Platform;
  }

  return 'web';
};

/**
 * Check if running on iOS
 */
export const isIOS = (): boolean => {
  return getPlatform() === 'ios';
};

/**
 * Check if running on Android
 */
export const isAndroid = (): boolean => {
  return getPlatform() === 'android';
};

/**
 * Check if running on native platform (iOS or Android)
 */
export const isNative = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * Check if running on web
 */
export const isWeb = (): boolean => {
  return !Capacitor.isNativePlatform();
};

